import { Component, OnInit, Input, OnChanges, Output, EventEmitter, HostListener, ElementRef, Renderer2, Directive } from '@angular/core';
import { LevelLinkageService } from './level-linkage.service'
import { CategoryOptionService } from '../../job/category-option/category-option.service';


@Component({
  selector: 'app-level-linkage',
  templateUrl: './level-linkage.component.html',
  styleUrls: ['./level-linkage.component.scss']
})
export class LevelLinkageComponent implements OnInit, OnChanges {
  hideLevelLinkage;//隐藏显示框
  @Input() allDataId: any = {}; //获取当前选中值的id
  @Input() level: string;//要获取数据级别；
  @Input() type: string;  //数据列别
  @Output() selectedData: any = new EventEmitter(); //返回选中数据

  public dataId: any = {};//省市区 地址id
  public dataName: any = {};// 省市区 地址名

  public outPutData: any;//返回的数据
  public dataList: any  //原始数据列表
  public levelTwoList: any;   //城市列表
  public levelThrList: any;    //地区列表
  //end
  public level1: boolean = false; //一级
  public level2: boolean = false; //二级
  public level3: boolean = false; //三级

  constructor(
    private el: ElementRef,
    public _levelLinkage: LevelLinkageService,
    public _categoryService: CategoryOptionService
  ) { }

  @HostListener('body:click', ['$event'])
  onClick(event: any) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.level1 = false;
      this.level2 = false;
      this.level3 = false;
    }
  }

  ngOnChanges() {
    // if (JSON.stringify(this.allDataId).toString() != "{}") {

    // }
    if (this.allDataId && JSON.stringify(this.allDataId).toString() != "{}") {
      this.dataId = this.allDataId['dataId'];
      this.dataName = this.allDataId['dataName'];
    } else {
      if (this.type == 'jobClass') {
        this.dataName['levelTwo'] = "请选择岗位类别";
      } else {
        this.dataName['levelTwo'] = "请选择地址";
      }
    }


    if (this.hideLevelLinkage) {
      this.level1 = false;
      this.level2 = false;
      this.level3 = false;
    } else {
      this.level1 = this.level1;
      this.level2 = this.level2;
      this.level3 = this.level3;
    }
  }


  ngOnInit() {
    if (this.type == 'addr') {
      this._levelLinkage.getList().then(resp => {
        if (resp.success) {
          this.dataList = resp['data'];
          this.changeOriginalData(this.dataList);  //组装数据函数
        }
      });
    } else if (this.type == 'jobClass') {
      this._categoryService.getCategoryJobClass().then(resp => {
        if (resp.success) {
          this.dataList = resp['data'];
          this.changeOriginalData(this.dataList);  //组装数据函数
        }
      })
    }
  }

  //组装数据函数
  changeOriginalData(data: any) {
    data.map(recOne => {
      recOne['levelOne'] = recOne['id'];
      if (!!recOne['children']) {
        recOne['children'].map(recTwo => {
          recTwo['levelTwo'] = recTwo['id'];
          if (!!recTwo['children']) {
            recTwo['children'].map(recThr => {
              recThr['levelThr'] = recThr['id'];
            })
          }
        })
      }
    })
  }


  //开启一级联动
  open() {
    this.level1 = true;
  }

  //点击省获取城市信息
  getLevel(obj: string, str: string) {
    switch (str) {
      case "level1":
        this.outPutData = [];
        this.outPutData.push({ id: obj['id'], name: obj['name'] });
        this.dataName['levelOne'] = obj['name'];    //设置name
        this.dataName['levelTwo'] = '';    //设置name
        this.dataName['levelThr'] = '';     //设置name
        this.dataId['levelOne'] = obj['id'];    //设置id值
        this.dataId['levelTwo'] = '';    //设置id值
        this.dataId['levelThr'] = '';    //设置id值
        this.dataList.map(res => {
          if (res['id'] === obj['id']) {
            if (!res['children']) {
              this.selectedData.emit(this.outPutData);
              this.level1 = false;
              this.level2 = false;
            } else {
              this.level1 = true;
              this.level2 = true;
              this.level3 = false;
            }
            this.levelTwoList = res['children'];
          }
        })
        break;
      case "level2":
        this.outPutData.length = 1;
        this.outPutData.push({ id: obj['id'], name: obj['name'] });
        this.dataName['levelTwo'] = obj['name'];
        this.dataName['levelThr'] = '';

        this.dataId['levelThr'] = '';
        this.dataId['levelTwo'] = obj['id'];

        if (this.level == "levelTwo") {
          this.selectedData.emit(this.outPutData);
          this.level1 = false;
          this.level2 = false;
          this.level3 = false;
        } else {
          this.levelTwoList.map(res => {
            if (res['id'] === obj['id']) {
              if (!res['children']) {
                this.selectedData.emit(this.outPutData);
                this.level1 = false;
                this.level2 = false;
                this.level3 = false;
              } else {
                this.level3 = true;
              }
              this.levelThrList = res['children']
            }
          })
        }
        break;
      case "level3":
        this.outPutData.push({ id: obj['id'], name: obj['name'] });
        this.dataName['levelThr'] = obj['name'];
        this.dataId['levelThr'] = obj['num'];
        this.selectedData.emit(this.outPutData);
        this.level1 = false;
        this.level2 = false;
        this.level3 = false;
        break;
    }
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/level-linkage/level-linkage.component.ts